import React from "react";
import { withRouter } from "react-router";

import SignupPageLayout from "./signup-page-layout";
import SignupForm from "./signup-form";
import AccountFeatures from "./account-features";
import getParameterByName from "../../../legacy/helpers/get_parameter_by_name";

const FormSectionContent = ({ signupType, plans, next }) => (
    <div>
        <SignupForm
            accentColor="green"
            plans={plans}
            next={next}
            signupType={signupType}
            showFacebookSignupLink
        />
    </div>
);

const SignupPage = props => {
    const { location } = props;
    const search = location && location.search;
    const next = props.next || getParameterByName("next", search) || "/";

    return (
        <SignupPageLayout
            formSectionContent={
                <FormSectionContent
                    signupType={props.signupType}
                    plans={props.plans}
                    next={next}
                />
            }
            featuresSectionContent={
                <AccountFeatures
                    signupType={props.signupType}
                    yearlyPrice={props.plans && props.plans.pro.yearly.price}
                />
            }
        />
    );
};

export const UnwrappedSignupPage = SignupPage;

export default withRouter(SignupPage);
